// Extracted from pwa/installPrompt.ts (Task 16, bagCache.ts's own offline-snapshot need) — the
// exact same private-browsing/partitioned-storage guard applies to ANY localStorage access in
// this app, not just install-prompt state, so this is now the one shared home for it rather than
// a second copy growing up independently in web/src/bag/bagCache.ts. installPrompt.ts's own
// module-level store still calls these (re-exported there is unnecessary — it imports straight
// from here now), so behavior is byte-for-byte identical to before the extraction.

// CRITICAL fix (reviewer finding, originally applied in installPrompt.ts): private-browsing /
// partitioned-storage contexts (notably older Safari private mode, and some partitioned
// third-party-storage configurations) can make even a plain `localStorage.getItem`/`setItem`
// call THROW, not just silently no-op or deny writes. installPrompt.ts runs this at module
// import time (via App.tsx), so an unguarded throw would have crashed app BOOT, not just one
// feature — every localStorage access in this app goes through one of these two helpers for
// exactly that reason.
export function safeGetItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeSetItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Degrades to "doesn't persist across reload" — never a crash. Callers still update
    // in-memory state regardless, so the feature keeps working for the rest of THIS session
    // even when it can't persist.
  }
}

// Phase 5 review-round addition (runPersist.ts's own `clearRun`, which previously stood in with
// `safeSetItem(key, '')` — a real key with an empty-string value, not an ABSENT key; harmless
// today only because `loadRun`'s `JSON.parse('')` failure already collapses to `null` the same
// way a genuinely-missing key would, but that's an accident of `loadRun`'s own error handling, not
// something a caller should have to rely on). Same guard as the other two helpers above.
export function safeRemoveItem(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // Same degrade-gracefully rationale as safeSetItem above.
  }
}
